import { Component, Input } from '@angular/core';
import { CurrencyDigitShortcutPipeInput } from 'src/app/pipes/pipes';
import { TranslatedCurrencyYearInputs } from 'src/app/pipes/translated-currency-input-keys';
import { ModalService } from 'src/app/services/modal/modal.service';
import { RedirectService } from 'src/app/services/redirect.service';
import { defaultRiskLevels } from '../constants';
import { ExpectedOwnedStrategy } from './strategy';

@Component({
  selector: 'libero-owned-strategy-card',
  templateUrl: './owned-strategy-card.component.html',
  styleUrls: ['./owned-strategy-card.component.scss'],
  standalone: false
})
export class OwnedStrategyCardComponent {
  @Input() public strategy!: ExpectedOwnedStrategy;
  @Input() public inCarousel = false;
  @Input() public isDraft = false;
  @Input() public hideActions? = false;
  @Input() public isMobile = false;

  public yearsShortcutsOptions: CurrencyDigitShortcutPipeInput = {
    units: TranslatedCurrencyYearInputs
  };

  public riskLevels = defaultRiskLevels;

  public toggled = false;

  // If user PORTFOLIO_MANAGEMENT and has some strategies, the guard takes a while
  // to allow the route, need to show strategy edit is loading
  public loadingForStrategyEdit = false;

  public get sliderMax(): number {
    return Math.max(...this.riskLevels);
  }

  public get positiveYield(): boolean {
    return parseInt(this.strategy.actualYield + '') > 0;
  }

  public constructor(
    private modalService: ModalService,
    private redirectService: RedirectService,
  ) { }

  public openMoneyDepositModal(): void {
    this.modalService.openMoneyDepositModal(this.strategy.portfolioId);
  }

  public deleteInvestment(): void {
    this.modalService.openInvestmentDelete(this.strategy);
  }

  public openDraftAcceptRefuseConfirm(portfolio: ExpectedOwnedStrategy, type: 'accept' | 'refuse'): void {
    if (portfolio.efektika && type === 'accept') {
      this.modalService.openEfektikaDraftAcceptConfirm(portfolio);
    } else {
      this.modalService.openDraftAcceptRefuseConfirm(portfolio, type, 'summary');
    }
  }

  public loadStrategyEditForPMWithStrategies(): void {
    this.loadingForStrategyEdit = true;
  }

  public goToAMLForm(): void {
    this.redirectService.goToAmlFormExternalForm();
  }

  public getTargetYearForDraft(): number {
    const now = new Date();
    if (!this.isDraft || !this.strategy) {
      return now.getFullYear();
    }
    now.setFullYear(now.getFullYear() + this.strategy.totalYearsToInvest);
    return now.getFullYear();
  }
}
